const messages = {
    accountBox: {
        title: "Nadzorna ploča",
        description: "Brzo pratite svoje promocije i bodove.",
        button: "OTVORI NADZORNU PLOČU",
    },
};

export default {
    messages,
};
